type GtmEventPayload = {
    event: string;
    [key: string]: unknown;
};

declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

export function pushGtmEvent(payload: GtmEventPayload): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!Array.isArray(window.dataLayer)) {
        return false;
    }

    window.dataLayer.push(payload);
    return true;
}